import React from "react";
import PropTypes from "prop-types";
import YouTube from "react-youtube";

const YouTubeVideo = (props) => {
  return (
    <section className={props.sectionClassNames}>
      {props.content.fieldGroesse === "0" && (
        <div className="full-width">
          <div className="iframe-wrap iframe-16-9">
            <YouTube videoId={props.content.fieldYoutubeVideoUrl.videoId} />
          </div>
        </div>
      )}
      {props.content.fieldGroesse === "1" && (
        <div className="container">
          <div className="row">
            <div className="col-18 col-lg-8 offset-lg-4">
              <div className="iframe-wrap iframe-16-9">
                <YouTube videoId={props.content.fieldYoutubeVideoUrl.videoId} />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

YouTubeVideo.propTypes = {
  content: PropTypes.shape({
    /**
     * 0 = 100%, 1 = 50%
     */
    fieldGroesse: PropTypes.oneOf(["0", "1"]),
    fieldYoutubeVideoUrl: PropTypes.shape({
      videoId: PropTypes.string.isRequired,
    }),
  }),
  sectionClassNames: PropTypes.string,
};

export default YouTubeVideo;